import { postApi } from "../components/Utility";
import { action, makeObservable, observable } from "mobx";
import config from '../config';
import { decode as base64_decode } from "base-64";
import Cookies from "js-cookie";
class TicketStore {
    ticketDetails = [];
    getVehiclesUsingCompanyId = []
    totalCount = 0;
    loading = false;
    rootStore;

    constructor(rootStore) {
        makeObservable(this, {
            addData: action,
            getTicketData: action,
            getTicketDetails: action,
            setPhotoFromDb: action,
            getVehiclesCompanyId: action,

            ticketDetails: observable,
            getVehiclesUsingCompanyId: observable,
            totalCount: observable,
        });
        this.rootStore = rootStore;
    }

    async addData(postData) {
        var response = await postApi
            .getClient("")
            // .post("http://localhost:4000/ticket/addTicketDetails", { postData });
            .post(config.NodeUrl + "/ticket/addTicketDetails", { postData });
        return response.data
    }

    async getTicketData({ offset, limit, searchField }) {
        const isadmin = JSON.parse(base64_decode(Cookies.get("data"))).isadmin
        const usercompanyId = JSON.parse(base64_decode(Cookies.get("data"))).userCompanyId
        const addedByUserId = JSON.parse(base64_decode(Cookies.get("data"))).userId
        this.loading = true
        const params = { isadmin: isadmin, usercompanyId: usercompanyId, addedByUserId: addedByUserId, offset: offset, limit: limit, };
        var response = await postApi
            .getClient("")
            // .get("http://localhost:4000/ticket/getTicketDetails", {
            //     params: params,
            // });
            .get(config.NodeUrl + "/ticket/getTicketDetails", {
                params: params,
            });

        this.ticketDetails = response?.data?.data
        this.totalCount = response?.data?.totalCount
        this.loading = false
        return response?.data?.data
    }

    async getTicketDetails({ ticketId, offset, limit }) {
        const isadmin = JSON.parse(base64_decode(Cookies.get("data"))).isadmin
        const usercompanyId = JSON.parse(base64_decode(Cookies.get("data"))).userCompanyId
        const addedByUserId = JSON.parse(base64_decode(Cookies.get("data"))).userId

        const params = { ticketId, isadmin, usercompanyId, addedByUserId: addedByUserId, limit: 1, offset: 0 };
        const response = await postApi
            .getClient()
            .get(config.NodeUrl + "/ticket/getTicketDetails", {
                params: params,
            });
        const singleRow = response?.data?.data[0];

        if (singleRow?.docs) {
            const fileList = [
                {
                    name: singleRow.docs,
                    status: "success",
                    url: config.fleetURL + "/images/invoices/" + singleRow.docs,
                },
            ];

            this.setPhotoFromDb(fileList);
        }
        return response?.data?.data[0];
    }

    async setPhotoFromDb(photo) {
        this.photoFromDb = { fileList: photo };
    }

    async getVehiclesCompanyId(companyId) {
        const params = {
            companyId: companyId
        }
        var response = await postApi
            .getClient("")
            // .get("http://localhost:4000/ticket/getVehicles", {
            //     params: params,
            // });
            .get(config.NodeUrl + "/ticket/getVehicles", {
                params: params,
            });
        this.getVehiclesUsingCompanyId = response?.data?.vehicleData;
        return response?.data?.vehicleData
    }
}
export default TicketStore;
